import sfxModal from './sfxModal';
import modalCloseButton from './modalCloseButton';

angular
    .module('sfx.modal', ['signalview.themeService'])
    .service('sfxModal', sfxModal)
    .directive('modalCloseButton', modalCloseButton);
